export default "__VITE_ASSET__CMEC3Wuj__"